import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CommonModule } from '@angular/common';
import { CarouselModule } from 'primeng/carousel';
import { TranslatePipe } from '@ngx-translate/core';
import { AppButton } from '../../../../client/components/atom/app-button/app-button';
import { ProductDto } from '../../../../../core/api/_dtos/product.dto';
import { ProductsService } from '../../../../../shared/services/data/products.service';
import { I18nService } from '../../../../../shared/services/i18n.service';

@Component({
  selector: 'app-promo-section',
  standalone: true,
  imports: [
    CommonModule,
    RouterLink,
    CarouselModule,
    TranslatePipe,
    AppButton,
  ],
  templateUrl: './promo-section.html',
  styleUrl: './promo-section.scss'
})
export class PromoSection implements OnInit {
  products: ProductDto[] = [];

  constructor(
    private productsService: ProductsService,
    private i18nService: I18nService
  ) {}

  ngOnInit(): void {
    this.productsService.getProducts(1, 3).subscribe(products => {
      this.products = products;
    });
  }

  get projectLink(): string {
    return this.i18nService.generateUrlWithLang('/project');
  }
}
